<template>
  <v-container fluid fill-height ma-0 pa-0 class="new-subscription">
    <v-layout row justify-center align-center ma-0 pa-0>
      <div class="error-message" v-if="error !== ''">
        <h4 class="error-text mb-4">{{error}}</h4>
        <v-icon x-large class="error--text">cancel</v-icon>
      </div>
      <div class="buy-content" v-else>
        <div class="initial-load" v-if="step === 0">
          <h4 class="loading-text mb-4">{{$tf('Please wait')}}...</h4>
          <v-progress-circular
              indeterminate
              color="primary"
              :size="70"
          ></v-progress-circular>
        </div>
        <v-stepper class="ma-0 pa-0 elevation-0" v-model="step" v-else>
          <v-stepper-header class="ma-0 pa-0 elevation-0">
            <v-stepper-step :complete="step > 1" step="1" :editable="step > 1 && step < 3">{{$tf('Payment method')}}
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">{{$tf('Checkout')}}</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">{{$tf('All set')}}</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <div>
                <p v-if="subscription">Only prorated part from previously used credit card ···· {{subscription.source.card.last4}}</p>
                <card-form v-else ref="addCardStripeForm"></card-form>
                <v-btn :key="2" @click.native="goToPayment" class="primary">{{$tf('Continue')}}</v-btn>
              </div>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-container grid-list-sm class="payment">
                <v-layout row class="header">
                  <v-flex xs6>
                    Concepto
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    Qty.
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    Precio
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    Total
                  </v-flex>
                </v-layout>
                <v-layout row class="concept">
                  <v-flex xs6>
                    <span>
                      {{plan.nickname}}
                    </span>
                    <span v-if="rate < 100">
                      PRORATED ({{rate}}%)
                    </span>
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    <select v-if="productInfo.metadata.multiple && productInfo.metadata.multiple === 'true'"
                            v-model="qty">
                      <option v-for="i of 20" :key="i" :value="i">{{i}}</option>
                    </select>
                    <span v-else>{{qty}}</span>
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    <span>{{currency(prorate(plan.amount, rate), plan.currency)}}</span>
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    <span>{{currency(prorate(plan.amount, rate) * qty, plan.currency)}}</span>
                  </v-flex>
                </v-layout>
                <v-layout row class="total">
                  <v-flex xs6></v-flex>
                  <v-flex xs4>
                    Total sin Impuestos
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    <span>{{currency(prorate(plan.amount, rate) * qty, plan.currency)}}</span>
                  </v-flex>
                </v-layout>
                <v-layout row class="tax">
                  <v-flex xs6></v-flex>
                  <v-flex xs4>
                    IVA (21%)
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    <span>{{currency(Math.floor(prorate(plan.amount, rate) * qty * 0.21), plan.currency)}}</span>
                  </v-flex>
                </v-layout>
                <v-layout row class="grand-total">
                  <v-flex xs6></v-flex>
                  <v-flex xs4>
                    TOTAL A PAGAR
                  </v-flex>
                  <v-flex xs2 class="text-xs-right">
                    <span>{{currency((prorate(plan.amount, rate) * qty) + Math.floor(prorate(plan.amount, rate) * qty * 0.21), plan.currency)}}</span>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-btn @click.native="checkout" class="primary">
                <v-icon dark left>shopping_cart</v-icon>
                {{$tf('Make payment')}}
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <div class="success-message ma-0 pa-0">
                <h4 class="success-text mb-4">{{$tf('Congratulations')}}</h4>
                <v-icon x-large class="success--text">check</v-icon>
              </div>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
  import Api from '~/store/idonia-api/api'
  import CardForm from '~/components/stripe/CardForm.vue'
  import AccountCards from '~/components/stripe/CardList.vue'
  import moment from 'moment'

  export default {
    name: 'new-subscription',
    components: {
      CardForm,
      AccountCards
    },
    props: {
      product: {
        type: String,
        default: ''
      },
      clientSecret: {
        type: String,
        default: ''
      },
      source: {
        type: String,
        default: ''
      },
      subscription: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data () {
      return {
        step: 0,
        stripe: window.Stripe(this.$config.stripeApiKey),
        level: {},
        error: '',
        src: '',
        productInfo: {},
        plan: {},
        qty: 1,
        bindedValue: false // Reload on close
      }
    },
    mounted () {
      this.step = 0
      if (this.source.length > 0 && this.clientSecret.length > 0) {
        window.setTimeout(() => {
          this.src = this.source
          this.stripe.retrieveSource({
            id: this.src,
            client_secret: this.clientSecret
          }).then(result => {
            this.plan = {
              id: result.source.metadata.plan_id
            }
            this.checkout()
          })
        }, 500)
      } else {
        this.load().then(() => {
          this.step = 1
        })
      }
    },
    computed: {
      rate () {
        if (this.subscription) {
          const daysInPeriod = moment.unix(this.subscription.current_period_end).diff(moment.unix(this.subscription.current_period_start), 'days')
          const daysUntilExpiration = moment.unix(this.subscription.current_period_end).diff(moment.now(), 'days')

          if (daysInPeriod <= 0) {
            return 100
          }

          return ((daysUntilExpiration * 100) / daysInPeriod).toFixed(2)
        }
        return 100
      }
    },
    methods: {
      goToPayment () {
        if (this.subscription) {
          this.src = this.subscription.source.id
          this.step = 2
        } else {
          this.$refs.addCardStripeForm.createSource().then(response => {
            this.src = response.source.id
            this.step = 2
          })
        }
      },
      checkout () {
        this.step = 0
        if (this.subscription) {
          Api.postV2('account/payment/subscription/' + this.subscription.id, {
            data: {
              quantity: this.qty
            }
          }).then(response => {
            this.step = 3
            this.$store.dispatch('dialog/setData', true)
            this.$store.dispatch('dialog/setValid', true)
          }).catch(response => {
            if (response.body && response.body.redirect_url) {
              window.location = response.body.redirect_url
            }
          })
        } else {
          Api.postV2('account/payment/subscription', {
            data: {
              plan: this.plan.id,
              source: this.src,
              quantity: this.qty
            }
          }).then(response => {
            this.step = 3
            this.$store.dispatch('dialog/setData', true)
            this.$store.dispatch('dialog/setValid', true)
          }).catch(response => {
            if (response.body && response.body.redirect_url) {
              window.location = response.body.redirect_url
            }
          })
        }
      },
      load () {
        return new Promise((resolve, reject) => {
          Api.getV2('account/level', {}).then(response => {
            this.level = response.body
            this.$store.dispatch('products/load').then(() => {
              this.productInfo = this.$store.getters['products/byId'](this.product)
              if (this.productInfo && this.productInfo.plans && this.productInfo.plans.length > 0) {
                this.plan = this.productInfo.plans[0]
                resolve()
              }
              reject(new Error('Product Not Found'))
            })
          }).catch(() => {
            this.error = this.$tf('UndefinedError') + '. ' + this.$tf('Try again later')
            reject(this.error)
          })
        })
      },
      prorate (amount, prorate) {
        return amount * prorate / 100
      },
      currency (amount, currency) {
        switch (currency) {
          case 'eur':
            let str = amount.toFixed(0)
            return str.slice(0, -2) + '.' + str.slice(-2) + '€'
          default:
            return 'ERROR'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .new-subscription {
    width: 100%;
    min-height: 350px;

    /deep/ .stepper {
      width: 100%;
      min-height: 350px;
    }

    .buy-content, .initial-load, .error-message, .success-message {
      width: 100%;
      min-height: 350px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .success-message i, .error-message i {
      font-size: 80px !important;
    }

    .payment {
      .header {
        font-weight: bold;
        border-bottom: 1px solid black;
      }
      .concept:nth-child(odd) {
        background-color: #eeeeee;
      }
      .total {
        border-top: 1px solid black;
      }
      .grand-total {
        font-weight: bolder;
        font-size: 15px;
      }
    }
  }

  select {
    -webkit-appearance: menulist;
    -moz-appearance: menulist;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialog/types/DialogNewSubscription.vue